import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import Select from 'react-select'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { XIcon } from '../Icons'

function AddTest({ onClose, onSuccess }) {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const generateError = (err) =>
    toast.error(err, {
      position: 'top-center',
    })

  const onSubmit = async (values) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}savetest`,
        {
          ...values,
          id: 0,
          start_date: startDate,
          end_date: endDate,
          formData: formData,
        },
        {
          withCredentials: true,
        }
      )
      if (data) {
        if (data.errors) {
          const { name, email, password } = data.errors
          if (name) generateError(name)
          else if (email) generateError(email)
          else if (password) generateError(password)
        } else {
          if (onSuccess) onSuccess()
          if (onClose) onClose()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const [formData, setFormData] = useState([])

  React.useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        if (onClose) onClose()
      }
    }
    window.addEventListener('keydown', handleEsc)
    return () => window.removeEventListener('keydown', handleEsc)
  }, [onClose])

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className="relative bg-white rounded-[20px] shadow-lg p-8 w-full max-w-lg mx-auto"
        style={{ maxHeight: '90vh', overflowY: 'auto' }}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-[#535862] hover:text-[#DE3C7D] focus:outline-none"
          aria-label="Close"
        >
          <XIcon />
        </button>
        <h4 className="card-title text-[#030303] font-bold text-xl pb-6">
          Add ACT Test
        </h4>
        <form
          className="form-sample"
          onSubmit={handleSubmit(onSubmit)}
          autoComplete="off"
        >
          <div className="grid grid-cols-2 gap-x-6 gap-y-4 pt-2">
            <div>
              <label className="block text-[#535862] font-medium mb-1">
                Test Code <span className="error text-[#DE3C7D]">*</span>
              </label>
              <input
                type="text"
                name="test_code"
                className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
                {...register('test_code', {
                  required: 'Test Code is required',
                })}
              />
              {errors.test_code && (
                <p className="text-[#DE3C7D] text-xs mt-1">
                  {errors.test_code.message}
                </p>
              )}
            </div>
            <div>
              <label className="block text-[#535862] font-medium mb-1">
                Test Title <span className="error text-[#DE3C7D]">*</span>
              </label>
              <input
                type="text"
                name="test_title"
                className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
                {...register('test_title', {
                  required: 'Test Title is required',
                })}
              />
              {errors.test_title && (
                <p className="text-[#DE3C7D] text-xs mt-1">
                  {errors.test_title.message}
                </p>
              )}
            </div>
            <div>
              <label className="block text-[#535862] font-medium mb-1">
                Start Date <span className="error text-[#DE3C7D]">*</span>
              </label>
              <DatePicker
                className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
              {errors.start_date && (
                <p className="text-[#DE3C7D] text-xs mt-1">
                  {errors.start_date.message}
                </p>
              )}
            </div>
            <div>
              <label className="block text-[#535862] font-medium mb-1">
                End Date <span className="error text-[#DE3C7D]">*</span>
              </label>
              <DatePicker
                className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
                selected={endDate}
                onChange={(date2) => setEndDate(date2)}
              />
              {errors.end_date && (
                <p className="text-[#DE3C7D] text-xs mt-1">
                  {errors.end_date.message}
                </p>
              )}
            </div>
          </div>
          <div className="flex justify-start gap-3 mt-8">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-md border border-[#F0F0F0] text-[#535862] bg-white hover:bg-neutral-50 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-md border border-[#DE3C7D] text-white bg-[#DE3C7D] hover:bg-[#c8356f] transition-colors font-medium"
            >
              Submit
            </button>
          </div>
          <ToastContainer />
        </form>
      </div>
    </div>
  )
}

export default AddTest
